import { createWidget } from '@alfa-bank/site-util-create-widget';
import { Link } from '@alfa-bank/site-link';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { TGeoInformerTitle, IDeps } from '../../models/geo-informer-title';
import { onChangeCity } from '../../utils/on-change-city';

import { GeoInformerTitle as Component } from './geo-informer-title';
import styles from './styles.css';
// TODO заменить GeolocationMapMIcon на импорт пакета, но он не поддерживает раскраску в нужный цвет
// -"@alfalab/icons-classic": "^2.1.0"
// -import { GeolocationMapMBlackIcon as Icon } from '@alfalab/icons-classic/GeolocationMapMBlackIcon';
import { GeoLocationMapMicon as Icon } from './geo-location-map-micon';

export const GeoInformerTitleDesktop = createWidget<IDeps, TGeoInformerTitle>({
    Link,
    Text,
    onChangeCity,
    Icon,
    styles,
})(Component);
